export default "__VITE_ASSET__BAm_xpTT__"